"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4226%3A524))
 * @trackcomponent
 * @lastsynced 2025-07-08T18:36:53.103Z
 * @optimized using svgo:^3.0.2
 */
export const Relationships = createSVGIcon(
  <>
    <path
      d="M13.71 15.402h.203s3.303.007 3.348 0l2.085-.383a.956.956 0 0 0 .784-.941V8.88a.96.96 0 0 0-.607-.89l-4.826-1.891a1.44 1.44 0 0 0-1.434.228L9.757 9.211a.736.736 0 0 0 .697 1.268l3.937-1.295"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m3.87 13.489 2.487.478 3.429 3.43a.96.96 0 0 0 .839.266l.478-.083a.96.96 0 0 0 .78-.78l.167-.97 1.634-.282.283-1.634 1.634-.282.282-1.634-2.487-2.487M11.589 7.704 10.174 6.29a.96.96 0 0 0-1.043-.209l-2.87 1.19-2.391.479"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.315h1.913a.956.956 0 0 1 .957.956v6.696a.957.957 0 0 1-.957.956H1zM21.087 7.271H23v8.609h-1.913a.96.96 0 0 1-.957-.957V8.228a.956.956 0 0 1 .957-.957Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Relationships",
  {
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
